export { default } from "./merge.js";